import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ReportProblemIcon(props: IconProps) {
    return <Icon {...props} iconKey={"report_problem"}/>
}
